import { app } from "./bootstrap";

const reactContext = require.context(
  "@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/react",
  true,
  /\.(j|t)sx?$/,
);

app.load(
  reactContext.keys().map((key) => {
    const name = key
      .replace(/^\.\//, "")
      .replace(/[._]controller\..*$/, "")
      .replace(/\//g, "--")
      .replace(/_/g, "-");

    const identifier = `react--${name}`;

    return {
      identifier,
      controllerConstructor: reactContext(key).default,
    };
  }),
);
